
export const UserSpaceLimitWarningMessage = "User Space occupied exceeds 90 percent of available space.";
export const CalculationsDatabaseLimitWarningMessage = "Calculation Database space occupied exceeds 90 percent of available space.";
export const CalculationsDatabaseAndUserSpaceLimitWarningMessage = "Calculation Database and User Space occupied exceeds 90 percent of available space.";
export const UserSpaceExceeded = "User Space Exceeded";
export const CalculationsDatabaseExceeded = "Calculations Database Exceeded";
export const CalculationsDatabaseAndUserSpaceExceeded = "Calculations Database and User Space Exceeded";
export class ErrorModel{
  code: string;
  message: string;
  success: string;
}
